<!-- subContWrap -->
<div class="subContWrap">
    <!-- subTop -->
    <div class="subTop">
        <ng-container *ngIf="activeFooter !== null && activeFooter !== undefined">
            <h2 class="bTit">{{ activeFooter.prgName }}</h2>
        </ng-container>
        <ul class="subMenu">
            <ng-container *ngFor="let item of footerMenu">
                <li><a (click)="onChangeLink(item)" [ngClass]="item.linkInfo === activeFooter.linkInfo ? 'on' : ''">{{ item.prgName }}</a></li>
            </ng-container>
        </ul>
    </div>
    <!-- //subTop -->
    <router-outlet></router-outlet>
</div>
